import { Button, Card, CardContent, FormControl, Grid, IconButton, InputAdornment, TextField, Typography } from '@mui/material'
import { CustomTimeline } from 'common'
import React from 'react'
import { ArrowLeftCircle, Paperclip, Send } from 'react-feather'
import { AllowedAccess } from 'react-permission-role'

export const LogBook = ({useFetchInit}) => {

  const {
    //------------- Generales
    //------------- globalStates
    globalStates,
    //------------- Helpers
    Helpers,
    //------------- Formularios
    Forms,
    //------------- FetchData
    FetchData,
    //------------- Actions
    Actions
} = useFetchInit

  const { FormLogBook:{formState, onInputChange} } = Forms

  const {onSendLog, handleClickCloseLogs} = Actions

  const {fetchInfoLogBook:{observations}} = FetchData

  return (
    <AllowedAccess permissions={['205_VEHICULOS_CREDITOS', '49_ADMIN']} renderAuthFailed={<p>Error</p>}>
          <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Card
                sx={{
                  maxHeight: '62vh',
                  overflowY: 'auto',
                  margin: '0 auto',
                  zIndex: 1,
                }}
              >
                <CardContent>
                  <Typography variant="h6" gutterBottom> Bitacora de cobros juridicos</Typography>
                  <div className="border-bottom border-dark"></div>
                  <CustomTimeline observations = {observations}/>
                </CardContent>
              </Card>
            </Grid> 
          </Grid> 
          <Grid container columnSpacing={{ xs: 12, sm: 12, md: 4, lg: 4 }} sx={{mt:1}}>
            <Grid item xs={12} sm={12} md={12} lg={12}>
              <Card
                sx={{
                  maxHeight: '25vh',
                  overflowY: 'auto',
                  margin: '0 auto',
                  zIndex: 1,
                }}
              >
              <CardContent>
                <FormControl fullWidth>
                    <label htmlFor="descripcion">Entrada de bitacora</label>
                    <TextField
                        id='descripcion'
                        name='descripcion'
                        value={ formState.descripcion } 
                        onChange={onInputChange}
                        size='small'
                        placeholder=''
                        type='text'
                        multiline
                        rows={4}
                        variant='outlined'
                        InputProps={{
                            endAdornment: (
                              <InputAdornment position="end">
                                <IconButton onClick={onSendLog}
                                >
                                  <Send />
                                </IconButton>
                                <IconButton
                                  // onClick={onSendLogs}
                                >
                                  <Paperclip />
                                </IconButton>
                              </InputAdornment>
                            )
                        }}
                    />
                    <Typography
                      variant="caption"
                      align="right"
                      color={formState.descripcion.length >= 500 ? 'error' : 'textSecondary'}
                    >
                      {formState.descripcion.length} / 500
                    </Typography> 
                </FormControl>
                <div className="text-center">
                  <Button 
                      startIcon={<ArrowLeftCircle/>}
                      variant="contained"
                      type="button" 
                      className='btn-round'
                      color='warning'
                      onClick={handleClickCloseLogs} 
                      sx={{ marginRight: 1, marginLeft: 1 }}
                  >
                      Volver
                  </Button>
                </div>
              </CardContent>
              </Card>
            </Grid> 
          </Grid> 

    </AllowedAccess>
  )
}
